import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { cloneDeep } from 'lodash';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import Select from '../../../common/Select.jsx';
import styles from '../../gen2_widgets/base/CommonSettings.module.scss';

const DATASET_ID_SETTINGS = [
      ["dataset_id", "dataset"],
      ["target_dataset_id", "target_dataset"],
]

export const NUMBER_UNIT_OPTIONS = ["hundreds", "thousands", "millions", "billions"];
export const NUMBER_PRECISION_OPTIONS = [0, 1, 2, 3, 4, 5];
export const DEFAULT_DATASET_SETTINGS = ["dataset_id", "name_item", "value", "number_unit", "number_precision"];

function DatasetSettingsRow({
    d,
    datasets,
    datasetsKey, 
    dataset_settings = ["dataset_id", "name_item", "value", "number_unit", "number_precision"],
    showGroupedDatasets,
    hideColorSelection,
    widgetId,
    settingsDatasets,
    index,
}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const main_value_ds = useSelector(state => state.dashboard.widgets[widgetId].settings?.main_value_ds);
    const updateDatasetSetting = (key, index, value) => {
        const currentDatasets = cloneDeep(datasets)
        let dataset = {...datasets[index]};
        dataset[key] = value
        currentDatasets[index] = dataset;
        setAttribute(`settings.${datasetsKey}`, currentDatasets);
    };
    const settingsDatasetOptions = settingsDatasets
                                    .filter((c) => (!c.group_by != 'fund' && !showGroupedDatasets) || (c.group_by != 'fund' && showGroupedDatasets))
                                    .map((c) => ({value: c.value ?? c.uuid, label: c.label ?? c.name}))
    return (
      <>
          {DATASET_ID_SETTINGS.filter((s) => dataset_settings.includes(s[0])).map((s) => (
            <label key={s[0]} className={styles['settings-option']}>
              {I18n.t(s[1])}
              <Select
                value={d[s[0]]}
                onChange={(v) => updateDatasetSetting(s[0], index, v)}
                options={[{value: "", label: I18n.t("select_from_list")}, ...settingsDatasetOptions]}
              />
            </label>
          ))}
          {dataset_settings.includes("name_item") ? (
            <label className={styles['settings-option']}>
              {I18n.t("name_item")}
              <input
                type="text"
                className="form-control"
                name="name_item"
                maxLength={70}
                data-index={index}
                value={d.name_item}
                onChange={(e) => updateDatasetSetting("name_item", e.target.dataset.index, e.target.value)}
              />
            </label>
          ) : null}
          {dataset_settings.includes("value") ? (
            <label className={styles['settings-option']}>
              {I18n.t("value")}
              <input
                type="text"
                className="form-control"
                name="value"
                data-index={index}
                value={d.value ?? d.uuid}
                onChange={(e) => updateDatasetSetting("value", e.target.dataset.index, e.target.value)}
              />
            </label>
          ) : null}
          {dataset_settings.includes("target") ? (
            <label className={styles['settings-option']}>
              {I18n.t("target")}
              <input
                type="text"
                className="form-control"
                name="target"
                data-index={index}
                value={d.target}
                onChange={(e) => updateDatasetSetting("target", e.target.dataset.index, e.target.value)}
              />
            </label>
          ) : null}
          {dataset_settings.includes("number_unit") ? (
            <label className={styles['settings-option']}>
              {I18n.t("number_unit")}
              <Select
                value={d.number_unit}
                options={[{value: "", label: I18n.t("number_unit_none")}, ...NUMBER_UNIT_OPTIONS.map((o) => ({value: o, label: I18n.t(`number_unit_${o}`)}))]}
                onChange={(v) => updateDatasetSetting("number_unit", index, v)}
              />
            </label>
          ) : null}
          {dataset_settings.includes("number_precision") ? (
            <label className={styles['settings-option']}>
              {I18n.t("number_precision")}
              <Select
                value={d.number_precision === void 0 ? 2 : d.number_precision}
                options={NUMBER_PRECISION_OPTIONS.map((o) => ({value: o, label: o}))}
                onChange={(v) => updateDatasetSetting("number_precision", index, v)}
              />
            </label>
          ) : null}
        {hideColorSelection ? null : (
          <label className={styles['settings-option']}>
            {I18n.t("background_color")}
            <ColorPicker 
            value={d.background_color} 
            onChange={(val) => updateDatasetSetting("background_color", index, val)}
            data-index={index} />
          </label>
        )}
        {dataset_settings.includes("main_value_ds") ? (
          <label className={styles['settings-row']}>
            {I18n.t("main_value_ds")} 
            <input className="ml-1" type="radio" name="is_main_value" value={d.id} checked={d.id === main_value_ds} onChange={(e) => setAttribute("settings.main_value_ds", d.id)}>
            </input>
          </label>
        ) : null }
      </>
    );
}

export default DatasetSettingsRow;
